import { useEffect, useState } from 'react';
import { TableCell } from '@mui/material';

const PriceCell = ({ previousSize, currentSize }) => {
    const [bgColor, setBgColor] = useState('transparent');

    useEffect(() => {
        if (previousSize == null || currentSize == null) return;

        if (previousSize < currentSize) {
            setBgColor('lightgreen');
        } else if (previousSize > currentSize) {
            setBgColor('lightcoral');
        }

        const timeout = setTimeout(() => {
            setBgColor('transparent');
        }, 1000);

        return () => clearTimeout(timeout);
    }, [previousSize, currentSize]);

    const formatNumber = (value) => {
        if (value == null || isNaN(value)) return '-';

        const [integerPart, decimalPart = ''] = value.toString().split('.');
        const withThousands = Number(integerPart).toLocaleString('de-DE');

        let formattedDecimals;
        if (decimalPart.length === 0) {
            formattedDecimals = '00';
        } else if (decimalPart.length === 1) {
            formattedDecimals = `${decimalPart}0`;
        } else {
            formattedDecimals = decimalPart;
        }

        return `${withThousands},${formattedDecimals}`;
    };

    return (
        <TableCell style={{ textAlign: 'right', backgroundColor: bgColor }}>
            {formatNumber(currentSize)}
        </TableCell>
    );
};

export default PriceCell;